// @flow
import React, { Fragment } from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import QuoteViewer from 'containers/quote/QuoteViewer';
import { type Match } from 'react-router-dom';
import QuoteCommentsContainer from 'containers/quote/QuoteCommentsContainer';
import QuoteSequencesContainer from 'containers/quote/QuoteSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Quote = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <QuoteViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <QuoteCommentsContainer />
      </PlainTemplate>
      <QuoteSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Quote;



// WEBPACK FOOTER //
// ./src/pages/Quote.js